import Flickity from 'flickity';

export default () => ({
    carousel2: null,
    carouselRefreshInterval: null,
    carouselTimeout: window.config.CAROUSELS.PROJECTS_ROW_CAROUSEL,

    init() {
        this.carousel2 = new Flickity(document.querySelector('.projects-carousel'), {
            prevNextButtons: false,
            cellAlign: "left",
            contain: true,
            autoplay: window.config.CAROUSELS.PROJECTS_ROW_CAROUSEL,
            adaptiveHeight: false,
            setGallerySize: true,
            imagesLoaded: true,
            pageDots: false,
            pauseAutoPlayOnHover: false,
            wrapAround: true,
            draggable: false
        });

        this.buttons = this.$el.querySelectorAll('.button');

        if (this.buttons.length > 0) {
            this.handleCarouselTimerButton();

            this.carousel2.on('select', () => {
                // this.carousel2.stopPlayer();

                this.buttons.forEach((button, index) => {
                    if (index === this.carousel2.selectedIndex) {
                        button.classList.add('active');
                        button.querySelector('.diamond-active-border').style.strokeDashoffset = '300px';
                    } else {
                        button.classList.remove('active');
                    }
                });

                // this.carousel2.playPlayer();
                this.handleCarouselTimerButton();
            });
        }
    },

    handleClick(index) {
        this.carousel2.select(index);
        this.carousel2.reposition();
    },

    handleCarouselTimerButton() {
        if (this.carouselRefreshInterval !== null) {
            clearInterval(this.carouselRefreshInterval);
        }

        let offset = 300;
        const intervalDuration = this.carouselTimeout / offset;

        this.carouselRefreshInterval = setInterval(() => {
            offset--;

            const currentButton = this.buttons[this.carousel2.selectedIndex];
            if (!currentButton) return;

            const diamondWhiteBorder
                = currentButton.querySelector('.diamond-active-border');
            if (diamondWhiteBorder) {
                diamondWhiteBorder.style.strokeDashoffset = `${offset}px`;
            }

            if (offset <= 0) {
                clearInterval(this.carouselRefreshInterval);
                this.carouselRefreshInterval = null;
                this.carousel2.next(true);
            }
        }, intervalDuration);
    },
});